import React, { useEffect } from 'react';
import { useStore } from '../store/useStore';
import Header from '../components/Header';
import StatCard from '../components/StatCard';
import ActionButton from '../components/ActionButton';

// Вспомогательная функция для агрегации статистики
const calculateAggregatedStats = (routes) => {
  const stats = {
    closed: { count: 0 },
    open: { count: 0 },
    undelivered: { count: 0 },
  };

  routes.forEach(route => {
    if (Array.isArray(route.receipts)) {
      route.receipts.forEach(receipt => {
        if (receipt.status === 'Закрыта') {
          stats.closed.count += 1;
        } else if (receipt.status === 'Открыта') {
          stats.open.count += 1;
        } else if (receipt.status === 'Не доставлено') {
          stats.undelivered.count += 1;
        }
      });
    }
  });

  return stats;
};

export default function MobileDashboard() {
  const {
    routes,
    loading,
    filters,
    fetchRoutes,
    toggleModal
  } = useStore();

  // Перезагружаем маршруты при изменении фильтров
  useEffect(() => {
    fetchRoutes();
  }, [filters, fetchRoutes]);

  if (loading) return <div>Загрузка...</div>;

  const stats = calculateAggregatedStats(routes);

  return (
    <div>
      <Header />

      {/* Карточки статистики */}
      <div style={{ display: 'flex', overflowX: 'auto', padding: '10px' }}>
        <StatCard title="Закрыто" value={stats.closed.count} />
        <StatCard title="Открыто" value={stats.open.count} />
        <StatCard title="Не доставлено" value={stats.undelivered.count} />
      </div>

      {/* Кнопки действий */}
      <div style={{ padding: '10px', display: 'flex', justifyContent: 'space-around' }}>
        <ActionButton onClick={() => toggleModal('isFiltersOpen')}>
          Фильтры
        </ActionButton>
        <ActionButton onClick={() => toggleModal('isRoutesSelectorOpen')}>
          Маршруты
        </ActionButton>
        <ActionButton onClick={() => toggleModal('isReportOpen')}>
          Отчёт
        </ActionButton>
      </div>
    </div>
  );
}
